export default {
  data() {
    return {
      facilitiesWithUnsignedNotes: null,
    };
  },
  methods: {
    async fetchUserFacilitiesWithUnsignedNotes() {
      try {
        const response = await this.$store.dispatch('facilities/getUserFacilitiesWithUnsignedNotes')
        this.facilitiesWithUnsignedNotes = response;
      } catch (error) {
        console.error('Error fetching user facilities with unsigned notes:', error);
      }
    },
  },
};
